import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'WaiverSignature' }

import { ref, onMounted } from 'vue'
import { fetchWaiverDetail, renderSignature } from '@/util/waiverSignature'

interface Props {
  waiverId?: number | string | null
  // Pre-decoded data-URL or raw blob; when provided the component renders it
  // directly and skips the network fetch.
  signature?: any
  // Caller's known flag from the list/aggregate payload. When false, the
  // component shows "no signature on file" without fetching.
  hasSignature?: boolean | null
  isMinor?: boolean
  notParticipating?: boolean
  signedDate?: string
  signerName?: string
  size?: 'cell' | 'row' | 'detail'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    waiverId: { default: null },
    signature: { default: null },
    hasSignature: { type: [Boolean, null], default: null },
    isMinor: { type: Boolean, default: false },
    notParticipating: { type: Boolean, default: false },
    signedDate: { default: '' },
    signerName: { default: '' },
    size: { default: 'detail' }
  },
  setup(__props: any, { expose }) {

const props = __props as { waiverId: number | string | null, signature: any, hasSignature: boolean | null, isMinor: boolean, notParticipating: boolean, signedDate: string, signerName: string, size: 'cell' | 'row' | 'detail' }



const state = ref<'idle' | 'loading' | 'loaded' | 'error' | 'none' | 'not-participating'>('idle')
const src = ref('')

const altText = () =>
  props.isMinor
    ? `Guardian signature${props.signerName ? ' for ' + props.signerName : ''}`
    : `Signature${props.signerName ? ' of ' + props.signerName : ''}`

async function load() {
  // No signature expected for non-participants.
  if (props.notParticipating) {
    state.value = 'not-participating'
    return
  }
  // Caller handed us the signature directly — render without a round trip.
  if (props.signature != null) {
    const decoded = renderSignature(props.signature)
    if (decoded) {
      src.value = decoded
      state.value = 'loaded'
    } else {
      state.value = 'none'
    }
    return
  }
  // Caller's flag already tells us there's nothing to fetch.
  if (props.hasSignature === false) {
    state.value = 'none'
    return
  }
  if (props.waiverId == null) {
    state.value = 'none'
    return
  }
  state.value = 'loading'
  try {
    const { waiver } = await fetchWaiverDetail(props.waiverId, { includeSignature: true })
    if (waiver && waiver.signature) {
      src.value = waiver.signature
      state.value = 'loaded'
    } else {
      state.value = 'none'
    }
  } catch (err) {
    // Never let a failed signature fetch take down the surface.
    // eslint-disable-next-line no-console
    console.error('Failed to load waiver signature', err)
    state.value = 'error'
  }
}

onMounted(load)

expose({ load })

return { __sfc: true,props, state, src, altText, load }
}

})